export default __webpack_public_path__ + "static/0-18481f55760ab3c78e10dfb158403f8f.jpg";